
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imonetizeit-alternative",
      function () {
        return require("private-next-pages/imonetizeit-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/imonetizeit-alternative"])
      });
    }
  